import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, setPropTypes, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import EditTextButton from '../../components/atoms/EditTextButton';
import GroupTablePagination from '../../components/atoms/GroupTablePagination';
import LoginGroupTextButton from '../../components/atoms/LoginGroupTextButton';
import ChangeEmailGroupTextButton from '../../components/atoms/ChangeEmailGroupTextButton';
import ChangeGochiKidFlagGroupTextButton from '../../components/atoms/ChangeGochiKidDonateFlagGroupTextButton';
import ChangeGochiKidUnlimitStatus from '../../components/atoms/ChangeGochiKidUnlimitStatus';
import BatchChangeShopStatusTextButton from '../../components/atoms/BatchChangeShopStatusTextButton';
import BatchChangeShopGochiKidTextButton from '../../components/atoms/BatchChangeShopGochiKidTextButton';
import ChangeGochiKidReceipt from '../../components/atoms/ChangeGochiKidReceipt';
import BatchChangeShopMenuPriceGochiKidTextButton from '../../components/atoms/BatchChangeShopMenuPriceGochiKidTextButton';

const styles = {
  root: {},
  overflow: {
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      totalCount: state.groups.totalCount,
      offset: state.groups.offset
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    groups,
    rowsPerPage,
    handleChangePage,
    page,
    totalCount,
    offset,
    editOpenAction,
    onOpenShopListTable,
    setRowsPerPage,
    handleChangePageAction,
    handeOpenSettingUnlimitGochiKidModal,
    handeOpenSettingGochiKidReceiptModal,
    processV2
  }) => {
    const loginToGroup = params => {
      let url = `/?cui=${params.cognitoUserId}&lts=true&sn=${encodeURIComponent(
        params.groupName
      )}&sid=${params.groupId}`;

      if (params.groupEducateSystem) {
        url = process.env.REACT_APP_EDUCATION_SYSTEM_MANAGE_WEB + url;
      }

      window.open(url, '_blank');
    };
    return (
      <div className={classes.root}>
        <div className={classes.overflow}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>グループID</TableCell>
                <TableCell>グループ名</TableCell>
                <TableCell>住所</TableCell>
                <TableCell>電話番号</TableCell>
                <TableCell>寄付可能設定</TableCell>
                <TableCell>
                  こどもごちめし
                  <br />
                  1,001円以上
                </TableCell>
                <TableCell>
                  こどもごちめし
                  <br />
                  レシート対応
                </TableCell>
                <TableCell />
                <TableCell />
                <TableCell />
                <TableCell />
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {groups.map(group => {
                return (
                  <TableRow key={group.groupId}>
                    <TableCell>
                      <EditTextButton
                        id={group.groupId}
                        onClickAction={() => editOpenAction(group.groupId)}
                      />
                    </TableCell>
                    <TableCell>
                      <Button
                        color="primary"
                        onClick={() => onOpenShopListTable(group.groupId)}
                      >
                        {group.groupId}
                      </Button>
                    </TableCell>
                    <TableCell>
                      <Button
                        color="primary"
                        onClick={() => onOpenShopListTable(group.groupId)}
                      >
                        {group.groupName}
                      </Button>
                    </TableCell>
                    <TableCell>
                      {' '}
                      {group.prefectures}
                      {` `}
                      {group.city}
                      {` `}
                      {group.address}
                      {` `}
                      {group.building}
                    </TableCell>
                    <TableCell>{group.phone}</TableCell>
                    <TableCell>
                      <ChangeGochiKidFlagGroupTextButton
                        textButton={
                          group.gochiKidDonateFlag === 1
                            ? '寄付可能'
                            : '寄付不可能'
                        }
                        groupId={group.groupId}
                        gochiKidDonateFlag={group.gochiKidDonateFlag}
                        handleChangePageAction={handleChangePageAction}
                      />
                    </TableCell>
                    <TableCell>
                      <ChangeGochiKidUnlimitStatus
                        checked={group.gochiKidUnlimit === 1}
                        handeOpenSettingUnlimitGochiKidModal={() => {
                          handeOpenSettingUnlimitGochiKidModal(group);
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <ChangeGochiKidReceipt
                        checked={group.gochiKidReceipt === 1}
                        handeOpenSettingGochiKidReceiptModal={() => {
                          handeOpenSettingGochiKidReceiptModal(group);
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <BatchChangeShopStatusTextButton
                        groupId={group.groupId}
                        processV2={processV2}
                      />
                    </TableCell>
                    <TableCell>
                      <BatchChangeShopGochiKidTextButton
                        groupId={group.groupId}
                        processV2={processV2}
                      />
                    </TableCell>
                    <TableCell>
                      <BatchChangeShopMenuPriceGochiKidTextButton
                        groupId={group.groupId}
                        processV2={processV2}
                      />
                    </TableCell>
                    <TableCell>
                      <ChangeEmailGroupTextButton
                        groupId={group.groupId}
                        email={group.email}
                      />
                    </TableCell>
                    <TableCell>
                      <LoginGroupTextButton
                        cognitoUserId={group.cognitoUserId}
                        groupName={group.groupName}
                        groupId={group.groupId}
                        groupEducateSystem={group.educateSystem}
                        onClickAction={loginToGroup}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <GroupTablePagination
            limit={rowsPerPage}
            setLimit={setRowsPerPage}
            handleChangePage={handleChangePage}
            totalCount={totalCount}
            selectedPage={page}
            offset={offset}
            handleChangeRowsPerPage={() => {}}
          />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
